// extracted by mini-css-extract-plugin
export var container = "_b0-0";
export var containerTopRight = "_b0-1";